'use client'

import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'
import { SESSION_EXPIRED_EVENT } from '@/libs/session-expired'

/**
 * Blocking dialog when Nest returns 401 (idle / session expired).
 * Mount once under Providers.
 */
const SessionExpiredDialog = () => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onExpired = () => setOpen(true)
    globalThis.addEventListener(SESSION_EXPIRED_EVENT, onExpired)
    return () => globalThis.removeEventListener(SESSION_EXPIRED_EVENT, onExpired)
  }, [])

  const handleOk = () => {
    setOpen(false)
    const pathname = globalThis.location.pathname
    const locale = pathname.startsWith('/ar') ? 'ar' : 'en'
    import('@/libs/auth-cross-tab').then(({ broadcastLogout }) => {
      broadcastLogout()
    })
    import('next-auth/react').then(({ signOut }) => {
      signOut({ redirect: false }).finally(() => {
        globalThis.location.href = `/${locale}/login`
      })
    })
  }

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Session expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have been logged out because there was no activity for 8 hours. Please log in again to continue.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleOk} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SessionExpiredDialog
